module.exports = __webpack_public_path__ + "static/media/openQuestion.3e52069f.svg";